const configuratorFilters = {
  oFilterForm: null,
  aFilterGroups: null,
  aFilterInputs: null,
  aFilterCheckboxes: null,
  aFilterSelects: null,
  aFilterHiddenInputs: null,
  oFilterResults: null,
  aProducts: null,
  oPagingButtons: null,
  oShowAllResultsButton: null,
  aClearFilterButton: null,
  oClearAllFiltersButton: null,
  oSliders: null,
  oMobileFilterToggles: null,
  oMobileFilters: null,
  oMobileFiltersListItems: null,
  oMobileFiltersLevelBack: null,
  aCreatedSliders: [],
  oAjaxTrigger: null,
  bSkipSliderHandle: false,
  oCurrentFilters: {},
  iCurrentPageNr: 1,
  root: null,
  lastYpos1: 0,
  lastYpos2: 0,
  openoninit:false,

  initialize: (useDeeplink, ajaxCallback, Vue = null) => {
    configuratorFilters.oFilterForm = document.forms.filterForm;
    configuratorFilters.aFilterGroups = document.querySelectorAll('.filter-title');
    configuratorFilters.aFilterInputs = document.querySelectorAll('.js-filter-form .checkbox input');
    configuratorFilters.aFilterCheckboxes = document.querySelectorAll('.js-filter-form input[type="checkbox"]');
    configuratorFilters.aFilterSelects = document.querySelectorAll('.js-filter-form select');
    configuratorFilters.aFilterHiddenInputs = document.querySelectorAll('.js-filter-form input[type="hidden"]');
    configuratorFilters.oFilterResults = document.querySelector('.js-filter-results');
    configuratorFilters.aClearFilterButton = document.querySelectorAll('.js-clear-filter');
    configuratorFilters.oClearAllFiltersButton = document.querySelectorAll('.js-clear-all');
    configuratorFilters.oMobileFilterToggles = document.querySelectorAll('.js-toggle-mobile-filters');
    configuratorFilters.oMobileFilters = document.querySelector('.js-mobile-filters');
    configuratorFilters.oMobileFiltersListItems = document.querySelectorAll('.js-filter-list-item');
    configuratorFilters.oMobileFiltersLevelBack = document.querySelectorAll('.js-filters-mobile-back');
    configuratorFilters.oSliders = document.querySelectorAll('.js-price-slider');
    configuratorFilters.oPagingButtons = document.querySelectorAll('.js-pagination-movepage');
    configuratorFilters.oShowAllResultsButton = document.querySelector('.js-pagination-showall');
    configuratorFilters.aProducts = document.querySelectorAll('.product');

    configuratorFilters.root = Vue;

    if (configuratorFilters.oSliders.length) {
      configuratorFilters.createSlider(ajaxCallback);
    }

    [].forEach.call(configuratorFilters.aFilterInputs, (input) => {
      input.addEventListener('change', (e) => {
        configuratorFilters.persistDisabledFilters(e);
      });
    });

    [].forEach.call(configuratorFilters.aFilterCheckboxes, (checkbox) => {
        checkbox.addEventListener('change', (e) => {
            
            var changeid = checkbox.id.replace("mob-", "").split('-')[0];

            [].forEach.call(configuratorFilters.aFilterCheckboxes, (otherCheckbox) => {
                if (otherCheckbox.checked) {

                    var otherid = otherCheckbox.id.replace("mob-", "").split('-')[0];
                    if (otherid === changeid && otherCheckbox !== checkbox) {

                        const sMultiSelect = checkbox.getAttribute('data-multi-select');

                        if (sMultiSelect !== "True") {
                            otherCheckbox.checked = false;
                            configuratorFilters.changeRelatedCheckbox(otherCheckbox);
                        }
                    }
                }
            }); 

            configuratorFilters.changeRelatedCheckbox(checkbox);
            configuratorFilters.filterProducts(e.target);

            /*if (checkbox.checked) {

                var filterwaarde = '';

                var filterwaarde1 = e.target.parentElement.getElementsByTagName('span')[0];
                    
                if (filterwaarde1)
                {
                    filterwaarde = filterwaarde1.getAttribute('data-filter-value');
                }

                if (!filterwaarde)
                {
                    filterwaarde = filterwaarde1.firstChild.nodeValue;
                }
                var filtertype = null;

                var top = e.target.closest(".configuratorfilters__item")

                if (top) {
                    filtertype = top.querySelector(".configuratorfilters__item__header").innerText;
                } else {
                    top = e.target.closest(".filters__mobile__level")
                    if (top) {
                        filtertype = top.querySelector(".filters__mobile__level__title").innerText;
                    }
                }

                if (filtertype && filterwaarde) {
                    window.dataLayer = window.dataLayer || [];
                    dataLayer.push({
                        'event': 'kies_productfilter',
                        'filtertype': filtertype,
                        'filterwaarde': filterwaarde.trim()
                    });
                }
            }*/
        
          });
    });

    [].forEach.call(configuratorFilters.oPagingButtons, (page) => {
      page.addEventListener('click', (e) => {
        e.preventDefault();
        configuratorFilters.filterProducts(e.currentTarget);
      });
    });

    [].forEach.call(configuratorFilters.aFilterSelects, (select) => {
      select.addEventListener('change', (e) => {
        configuratorFilters.filterProducts(e.target);
      });
    });

    [].forEach.call(configuratorFilters.aProducts, (product) => {
      product.addEventListener('click', () => {
        docCookies.setItem('configuratorFiltersScrollTo', `${product.dataset.articlecode}`, '', '/');
      });
    });

    if (configuratorFilters.oShowAllResultsButton !== null) {
      configuratorFilters.oShowAllResultsButton.addEventListener('click', (e) => {
        e.preventDefault();
        configuratorFilters.filterProducts(e.target);
        return false;
      });
    }

    [].forEach.call(configuratorFilters.oClearAllFiltersButton, (button) => {
      button.addEventListener('click', configuratorFilters.clearAllFilters);
    });

    [].forEach.call(configuratorFilters.aClearFilterButton, (button) => {
      button.addEventListener('click', configuratorFilters.clearFilter);
    });

    [].forEach.call(configuratorFilters.oMobileFilterToggles, (toggle) => {
      toggle.addEventListener('click', configuratorFilters.toggleMobileFilters);
    });

    [].forEach.call(configuratorFilters.oMobileFiltersListItems, (item) => {
      item.addEventListener('click', (e) => {
        configuratorFilters.openFilterLevel(item);
      }, false);
    });

    [].forEach.call(configuratorFilters.oMobileFiltersLevelBack, (item) => {
      item.addEventListener('click', (e) => {
        configuratorFilters.closeFilterLevel(e, item);
      });
    });

    // Get Filters from Url, Map them to OverviewFilters Object and preload filters
    if (useDeeplink && window.location.search !== '') {
      const oPreloadOverviewFilters = configuratorFilters.getFiltersFromHash();
      configuratorFilters.loadFiltersFromDeeplink(oPreloadOverviewFilters);
    } else {
      configuratorFilters.removeHiddenClass();
      configuratorFilters.scrollToProduct();
    }

    window.onpopstate = (e) => {
      let oPreloadOverviewFilters;
      oPreloadOverviewFilters = e.state != null ? oPreloadOverviewFilters = e.state : oPreloadOverviewFilters = configuratorFilters.getFiltersFromHash();
      configuratorFilters.loadFiltersFromDeeplink(oPreloadOverviewFilters);

      if (website.body.classList.contains('no-scroll')) {
        website.body.classList.remove('no-scroll');
      }
    };

      configuratorFilters.removeLoadingClass();

      const mobileFiltersUsed = (website.iScreenWidth < website.mobileBreakpoint);

      if (configuratorFilters.openoninit && mobileFiltersUsed && !configuratorFilters.oAjaxTrigger && !configuratorFilters.oMobileFilters.classList.contains('filters__mobile--active')) {
        configuratorFilters.oMobileFilters.classList.remove('d-none');
        configuratorFilters.oMobileFilters.classList.add('d-flex');
        configuratorFilters.oMobileFilters.classList.add('filters__mobile--active');

        if (!website.body.classList.contains('no-scroll')) {
            website.body.classList.add('no-scroll');
        }
      }
  },
  getFiltersFromHash: () => {
    const oPreloadOverviewFilters = configuratorFilters.newOverviewFilters();
    const aFilterTypes = (window.location.search.replace('?', '')).split('&');

    for (let iType = 0; iType < aFilterTypes.length; iType += 1) {
      const aKeyValues = aFilterTypes[iType].split('=');

      if (Array.isArray(oPreloadOverviewFilters[aKeyValues[0]])) {
        oPreloadOverviewFilters[aKeyValues[0]] = aKeyValues[1].split(';');
      } else {
        oPreloadOverviewFilters[aKeyValues[0]] = aKeyValues[1];
      }
    }

    return oPreloadOverviewFilters;
  },
  setInnerHTML: (elm, html) => {
    elm.innerHTML = html;

    Array.from(elm.querySelectorAll("script"))
        .forEach(oldScriptEl => {
            const newScriptEl = document.createElement("script");

            Array.from(oldScriptEl.attributes).forEach(attr => {
                newScriptEl.setAttribute(attr.name, attr.value)
            });

            const scriptText = document.createTextNode(oldScriptEl.innerHTML);
            newScriptEl.appendChild(scriptText);

            oldScriptEl.parentNode.replaceChild(newScriptEl, oldScriptEl);
        });
  },
    filterProducts: (trigger) => {
      // Set isLoading in App.js
      if (configuratorFilters.root !== null) {
          configuratorFilters.root.isLoading = true;
      }

      //configuratorFilters.oFilterForm.classList.add('is-loading');
      configuratorFilters.oAjaxTrigger = trigger;

      let formContainer = configuratorFilters.oFilterForm.querySelector('.configuratorfilters'); // Desktop filters
      const mobileFiltersUsed = (website.iScreenWidth < website.mobileBreakpoint);

      if (mobileFiltersUsed) {
          formContainer = configuratorFilters.oMobileFilters;
      }

      if (configuratorFilters.oAjaxTrigger) {
          if (configuratorFilters.oAjaxTrigger.classList.contains('js-pagination-showall')) {
              configuratorFilters.iCurrentPageNr = 0;
          } else if (configuratorFilters.oAjaxTrigger.classList.contains('js-pagination-movepage') ||
              configuratorFilters.oAjaxTrigger.parentElement.classList.contains('js-pagination-movepage')) {
              const iTriggerPageNr = configuratorFilters.oAjaxTrigger.getAttribute('data-page') ||
                  configuratorFilters.oAjaxTrigger.parentElement.getAttribute('data-page');

              if (iTriggerPageNr !== null) {
                  configuratorFilters.iCurrentPageNr = parseInt(iTriggerPageNr, 10);
              }
          } else {
              configuratorFilters.iCurrentPageNr = 1;
          }
      }

      if (configuratorFilters && configuratorFilters.oAjaxTrigger && configuratorFilters.oAjaxTrigger.id === 'productlist__sort')
      {
          window.dataLayer = window.dataLayer || [];
          dataLayer.push({
              'event': 'gebruik_sortering',
              'sorteringkeuze': configuratorFilters.oAjaxTrigger.options[configuratorFilters.oAjaxTrigger.selectedIndex].text
          });
      }

      configuratorFilters.setOverviewFilters(configuratorFilters.newOverviewFilters(),
          formContainer,
          configuratorFilters.iCurrentPageNr);

      const postUrl =
          (`/ConfiguratorFilter/OverviewAjax?contentId=${currContentId}&pageNr=${configuratorFilters.iCurrentPageNr}`);

      fetch(postUrl,
              {
                  method: "POST",
                  headers: {
                      "Content-Type": "text/html; charset=UTF-8",
                      "Accept-Language": document.documentElement.lang,
                      "X-Requested-With": "XMLHttpRequest"
                  },
                  body: JSON.stringify(configuratorFilters.oCurrentFilters),
                  credentials: 'same-origin',
              })
          .then(response => response.text())
          .then((response) => {
              var list = document.querySelectorAll('.filters__mobile__configuratorcontent');
              if (list) {
                  configuratorFilters.lastYpos1 = list[0].scrollTop;
              }

              var list2 = document.querySelectorAll('.configuratorfilters--scrollable');
              if (list2) {
                  configuratorFilters.lastYpos2 = list2[0].scrollTop;
              }
              
              configuratorFilters.destroySliders();

              //configuratorFilters.oFilterResults.innerHTML = response;
              configuratorFilters.setInnerHTML(configuratorFilters.oFilterResults, response);

              fBackToTop();
              fTooltip();
              fInitCustomSelects();
              fAccordion();
              initModals();
              configuratorFilters.initialize(false, true, configuratorFilters.root);

              if (mobileFiltersUsed) {
                  if (configuratorFilters.oAjaxTrigger) {
                      if (!(configuratorFilters.oAjaxTrigger.classList.contains('js-pagination-showall') ||
                          configuratorFilters.oAjaxTrigger.classList.contains('js-pagination-movepage') ||
                          //configuratorFilters.oAjaxTrigger.classList.contains('js-clear-all') ||
                          configuratorFilters.oAjaxTrigger.id === 'productlist__sort')) {
                          configuratorFilters.toggleMobileFilters();
                          const oMobileTrigger = document.getElementById(`${configuratorFilters.oAjaxTrigger.id}`);
                          if (oMobileTrigger) {

                              const oMobileTriggerParent = oMobileTrigger.closest('.js-filter-list-item');
                              configuratorFilters.openFilterLevel(oMobileTriggerParent);
                              var list3 = document.querySelectorAll('.filters__mobile__configuratorcontent');
                              if (list3) {
                                  list3[0].scrollTop = configuratorFilters.lastYpos1;
                              }
                          }
                      } else {
                          website.body.classList.remove('no-scroll');
                      }
                  }
              } else {
                  var list4 = document.querySelectorAll('.configuratorfilters--scrollable');
                  if (list4) {
                      list4[0].scrollTop = configuratorFilters.lastYpos2;

                      setTimeout(() => {
                          window.scrollTo(0, 0);
                          }, 0);
                  }
              }

              setTimeout(() => {
                      configuratorFilters.updateOverviewUrlHash(mobileFiltersUsed, configuratorFilters.iCurrentPageNr);
                      configuratorFilters.scrollToProduct();

                      if (configuratorFilters.oAjaxTrigger) {
                          if (configuratorFilters.oAjaxTrigger.classList.contains('js-pagination-showall') ||
                              configuratorFilters.oAjaxTrigger.classList.contains('js-pagination-movepage') ||
                              configuratorFilters.oAjaxTrigger.classList.contains('js-clear-all') ||
                              configuratorFilters.oAjaxTrigger.id === 'productlist__sort') {
                              window.scrollTo(0, 0);
                          }
                      }
                    },
              0);
                
              if (configuratorFilters.root !== null) {
                  configuratorFilters.root.isLoading = false;
              }

              configuratorFilters.removeLoadingClass();
              configuratorFilters.removeHiddenClass();
              configuratorFilters.enableFilterWithoutResults();


              if (typeof initFlowBox != "undefined") {
                  setTimeout(() => {
                      initFlowBox();
                  },
                      2000);
              }
              
          });
  },
  persistDisabledFilters: (event) => {
    const oChk = event.target;
    const oHidClones = configuratorFilters.oFilterForm.querySelectorAll(`#hid${oChk.getAttribute('id')}, #hid${oChk.getAttribute('id')}`); // Find the matching hidden input field

    if (oHidClones) {
      if (oHidClones.length > 1) {
        [].forEach.call(oHidClones, (clone) => {
          clone.value = '';
          if (oChk.checked && oChk.disabled) {
            clone.value = oChk.value;
          }
        });
      } else {
        oHidClones[0].value = ''; // Reset the hidden field first (no value until proven guilty)

        // Only copy the value to the hidden field if its related checkbox is momentarily
        // both checked and disabled, as otherwise it won't be needed
        if (oChk.checked && oChk.disabled) {
          oHidClones[0].value = oChk.value;
        }
      }
    }
  },
  changeRelatedCheckbox: (checkbox) => {
    let relatedCheckbox;
    if (checkbox.id.indexOf('mob-') > -1) {
      const sStrippedCheckboxId = checkbox.id.replace('mob-', '');
      relatedCheckbox = configuratorFilters.oFilterForm.querySelector(`#${sStrippedCheckboxId}`);
    } else {
      relatedCheckbox = configuratorFilters.oFilterForm.querySelector(`#mob-${checkbox.id}`);
    }

      relatedCheckbox.checked = checkbox.checked;
  },
  updateOverviewUrlHash: (mobileFiltersUsed, pageNr) => {
      let formContainer = document.querySelector('.configuratorfilters');

    if (typeof mobileFiltersUsed === 'undefined') {
      mobileFiltersUsed = false;
    }

    if (mobileFiltersUsed) {
      formContainer = document.querySelector('.js-mobile-filters');
    }

    const oOverviewFilters = configuratorFilters.newOverviewFilters();
    configuratorFilters.setOverviewFilters(oOverviewFilters, formContainer, pageNr);

    const sHashUrl = `?${configuratorFilters.getJsonFilterVals(oOverviewFilters)}`;
    if (window.location.search !== sHashUrl) {
      if (sHashUrl !== '?') {

        window.history.replaceState(undefined, undefined, sHashUrl);

        //window.history.pushState(oOverviewFilters, 'deeplink', sHashUrl);
      } else {
          window.history.replaceState(oOverviewFilters, 'initialState', window.location.pathname );
      }
    }

  },
  newOverviewFilters: () => {
    const oFilters = {
        page: 1,
        sort: ''
    };

    var filters = document.getElementsByClassName('filters');
    if (filters) {
        var dataset = filters[0].dataset.filters;
        if (dataset) {
            dataset.split(';').forEach(tag => {
                oFilters[tag] = [];
            });
        }
    }

    return oFilters;
  },
  setOverviewFilters: (oFilters, oForm, pageNr) => {
    const oFields = Array.prototype.slice.call(oForm.querySelectorAll('.js-filter-form input[type="checkbox"]:checked'));
    const oSelects = Array.prototype.slice.call(document.querySelectorAll('.js-filter-form select'));

    oFields.push(...oSelects);

    for (let i = 0; i < oFields.length; i += 1) {
      const oField = oFields[i];
      const sFilterType = oField.getAttribute('name');
      const sFilterVal = oField.value;

      if (oField.type === 'checkbox') {
        oFilters[sFilterType].push(sFilterVal);
      } else {
        oFilters[sFilterType] = sFilterVal;
      }
    }

      [].forEach.call(oForm.querySelectorAll('.js-price-slider-selected-max'),
          max => {
              var parent = max.parentElement;
              var min = parent.querySelector('.js-price-slider-selected-min');
              var minDefault = parent.querySelector('.js-price-slider-min');
              var maxDefault = parent.querySelector('.js-price-slider-max');

              if (max.value !== maxDefault.value || min.value !== minDefault.value) {
                  oFilters[min.getAttribute('name')] = min.value;
                  oFilters[max.getAttribute('name')] = max.value;

                  oFilters[minDefault.getAttribute('name')] = minDefault.value;
                  oFilters[maxDefault.getAttribute('name')] = maxDefault.value;

              } else {
                  delete oFilters[min.getAttribute('name')];
                  delete oFilters[max.getAttribute('name')];

                  delete oFilters[minDefault.getAttribute('name')];
                  delete oFilters[maxDefault.getAttribute('name')];

              }
          });


    oFilters.page = pageNr;
    configuratorFilters.iCurrentPageNr = pageNr;

    configuratorFilters.oCurrentFilters = oFilters;
  },
  getJsonFilterVals: (oAppliedFilters) => {
    let sHash = '';
    let sPrevArrFilter = '';
    const oAppliedFiltersKeys = Object.keys(oAppliedFilters);

    const defaultFilters = configuratorFilters.newOverviewFilters();
      
    if (JSON.stringify(defaultFilters) !== JSON.stringify(oAppliedFilters)) {
      oAppliedFiltersKeys.forEach((filterType) => {
        if (Array.isArray(oAppliedFilters[filterType])) {
          oAppliedFilters[filterType] = oAppliedFilters[filterType].filter((v, i) => oAppliedFilters[filterType].indexOf(v) === i);

          if (oAppliedFilters[filterType].length > 0) {
            const aFilterVals = oAppliedFilters[filterType];

            if (sHash === '') {
              sHash = `${filterType}=${oAppliedFilters[filterType][0]}`;
            } else if ((sHash !== '') && (sPrevArrFilter !== filterType)) {
              sHash += `&${filterType}=${oAppliedFilters[filterType][0]}`;
            }

            for (let iFilter = 0; iFilter < aFilterVals.length; iFilter += 1) {
              if (iFilter > 0) {
                sHash += `;${aFilterVals[iFilter]}`;
              }
            }
            sPrevArrFilter = filterType;
          }
        } else {

          if (filterType === 'page' && oAppliedFilters[filterType] === 1) {
             return;
          }
          else if (filterType !== 'page' && oAppliedFilters[filterType].length === 0) {
             return;
          }
          else if (sHash !== '') {
             sHash += '&';
          }

          sHash += `${filterType}=${oAppliedFilters[filterType]}`;
        }
      });
    }

    return sHash;
  },
  loadFiltersFromDeeplink: (oPreloadOverviewFilters) => {
    const oPreloadOverviewFiltersKeys = oPreloadOverviewFilters !== null
      ? Object.keys(oPreloadOverviewFilters)
      : Object.keys(configuratorFilters.newOverviewFilters());

    // Disable all filters
    [].forEach.call(configuratorFilters.aFilterHiddenInputs, (input) => {
      const oInput = input;
      if (oInput.nextElementSibling !== null && oInput.nextElementSibling.type === 'checkbox') {
        oInput.value = '';
      }
    });

    [].forEach.call(configuratorFilters.aFilterCheckboxes, (checkbox) => {
      const oCheckbox = checkbox;
      oCheckbox.checked = false;
    });

    if (oPreloadOverviewFilters !== null) {
      oPreloadOverviewFiltersKeys.forEach((filterType) => {
        if (oPreloadOverviewFilters !== null && Array.isArray(oPreloadOverviewFilters[filterType])) {
          if (oPreloadOverviewFilters[filterType].length > 0) {
            const aFilterValues = oPreloadOverviewFilters[filterType];
              for (let iFilter = 0; iFilter < aFilterValues.length; iFilter += 1) {
              configuratorFilters.selectCheckbox(aFilterValues[iFilter], filterType);
              configuratorFilters.setHiddenInputValues(aFilterValues[iFilter], filterType);
            }
          }
        } else {
          const filterValue = oPreloadOverviewFilters[filterType];
          configuratorFilters.setHiddenInputValues(filterValue, filterType);
        }
      });
    }

    if (oPreloadOverviewFilters !== null) {
      configuratorFilters.iCurrentPageNr = parseInt(oPreloadOverviewFilters.page, 10);
    }

    configuratorFilters.filterProducts(null);
  },
  clearFilter: (e) => {
    const sFilterValue = e.target.getAttribute('data-filter-value');
    const sFilterType = e.target.getAttribute('data-filter-type');
    if (sFilterType === 'checkbox') {
        const sFilterKey = e.target.getAttribute('data-filter-key');

        configuratorFilters.selectCheckbox(sFilterValue, sFilterKey, true);
    } else {
        configuratorFilters.resetSliders(sFilterType);
    }

    configuratorFilters.filterProducts(e.target);
    e.preventDefault();
  },
  clearAllFilters: (e) => {
    [].forEach.call(configuratorFilters.aFilterCheckboxes, (checkbox) => {
      const oCheckbox = checkbox;
      oCheckbox.checked = false;
    });

    configuratorFilters.resetSliders();
    configuratorFilters.filterProducts(e.target);
    e.preventDefault();
  },
    selectCheckbox: (value, type, clear = false) => {
    [].forEach.call(configuratorFilters.aFilterCheckboxes, (checkbox) => {
      const oCheckbox = checkbox;

      const sCheckboxName = oCheckbox.getAttribute('name');
        
      if ((type === '' || type === sCheckboxName) && oCheckbox.value === value) {
          oCheckbox.checked = !clear;
      }
    });
  },
  setHiddenInputValues: (value, type) => {
    [].forEach.call(configuratorFilters.aFilterHiddenInputs, (input) => {
      const oInput = input;
      const sInputName = oInput.getAttribute('name');

      if (type.indexOf("min") === 0 && sInputName === type) {
        configuratorFilters.setSliderValues(input, value, null);
      } else if (type.indexOf("max") === 0 && sInputName === type) {
        configuratorFilters.setSliderValues(input, null, value);
      } else if (oInput.id === `hid${type + value}`) {
        oInput.value = value;
      }
    });

    [].forEach.call(configuratorFilters.aFilterSelects, (select) => {
      if (select.getAttribute('name') === type) {
        select.value = value;
      }
    });
  },
  createSlider: (ajaxCallback) => {
      [].forEach.call(configuratorFilters.oSliders, (slider) => {
        const oSlider = slider.querySelector('.range-slider__slider');

      const maxValue = parseFloat(slider.querySelector('.js-price-slider-max').value, 10);
      const minValue = parseFloat(slider.querySelector('.js-price-slider-min').value, 10);

      const selectedActualMinValue = slider.querySelector('.js-price-slider-selected-min');
      const selectedActualMaxValue = slider.querySelector('.js-price-slider-selected-max');
      const selectedSliderText = slider.querySelector('.js-selected-price-range');
      const selectedSliderTextMin = selectedSliderText.querySelector('.js-selected-price-range-min');
      const selectedSliderTextMax = selectedSliderText.querySelector('.js-selected-price-range-max');

      var hostLanguage = document.documentElement.lang;

      const step = 1;
      var margin = Math.ceil((maxValue - minValue) / (11 * step)) * step

      const oOptions = {
          start: [selectedActualMinValue.value, selectedActualMaxValue.value],
        range: {
            min: [minValue],
            max: [maxValue],
        },
        //behaviour: 'drag',
        connect: true,
        margin: margin,
        //step: step,
        cssPrefix: 'hbf-',
        format: {
          to: value => `${Math.round(value)}`,
          from: value => value,
        },
        tooltips: [
          {
              to: value => `${Math.round(value)}`,
              from: value => value,
          },
          {
            to: value => `${Math.round(value)}`,
            from: value => value,
          },
        ]
      };

      noUiSlider.create(oSlider, oOptions);

      oSlider.noUiSlider.on('update', (values, handle) => {
        if (!configuratorFilters.bSkipSliderHandle) { // Prevents the AJAX call from being called for both handles each time one is moved
          const handleTooltips = oSlider.querySelectorAll('.hbf-handle .hbf-tooltip');

          selectedSliderTextMin.textContent = `${handleTooltips.item(0).innerHTML}`;
          selectedSliderTextMax.textContent = `${handleTooltips.item(1).innerHTML}`;
          selectedActualMinValue.value = values[0].replace('€', '');
          selectedActualMaxValue.value = values[1].replace('€', '');

          configuratorFilters.bSkipSliderHandle = true;
        } else {
          configuratorFilters.bSkipSliderHandle = false;
        }
      });

      oSlider.noUiSlider.on('end', (values, handle, unencoded, tap, positions) => {
        const min = Math.round(unencoded[0]).toString();
        const max = Math.round(unencoded[1]).toString();

        const maxV = parseInt(slider.querySelector('.js-price-slider-max').value, 10);
        const minV = parseInt(slider.querySelector('.js-price-slider-min').value, 10);

        if (minV !== min || maxV !== max) {
          configuratorFilters.filterProducts(oSlider.parentElement);
        }
      });

      configuratorFilters.aCreatedSliders.push(oSlider);
    });
  },
  resetSliders: (sFilterType) => {
      [].forEach.call(configuratorFilters.aCreatedSliders, (slider) => {

          if (typeof sFilterType === 'undefined' || slider.noUiSlider.target.parentElement.id.includes(sFilterType)) {

              // Reset slider only if current values dont match the starting values
              const aStartingSliderValues = [];
              aStartingSliderValues.push(slider.noUiSlider.options.range.min[0], slider.noUiSlider.options.range.max[0]);

              const aCurrentSliderValuesStripped = [];
              const aCurrentSliderValues = slider.noUiSlider.get();
              [].forEach.call(aCurrentSliderValues, (value) => {
                      aCurrentSliderValuesStripped.push(parseFloat(value.replace('€', '')));
                  });

              if (JSON.stringify(aStartingSliderValues) !== JSON.stringify(aCurrentSliderValuesStripped)) {
                  slider.noUiSlider.set(aStartingSliderValues);
              }
          }
      });
  },
  destroySliders: () => {
    [].forEach.call(configuratorFilters.oSliders, (slider) => {
      if (typeof slider.noUiSlider === 'object') {
        slider.noUiSlider.destroy();
      }
      configuratorFilters.aCreatedSliders.splice(0, 1);
    });
    },
    setSliderValues: (input, min, max) => {
        [].forEach.call(configuratorFilters.aCreatedSliders, (slider) => {
            if (slider.noUiSlider.target.parentElement === input.parentElement) {
              slider.noUiSlider.set([min, max]);
          }
      });
  },
    toggleMobileFilters: (event) => {
    if (configuratorFilters.oMobileFilters.classList.contains('filters__mobile--active')) {
      configuratorFilters.oMobileFilters.classList.remove('filters__mobile--active');
        website.body.classList.remove('no-scroll');
    } else {
      configuratorFilters.oMobileFilters.classList.remove('d-none');
      configuratorFilters.oMobileFilters.classList.add('d-flex');
      configuratorFilters.oMobileFilters.classList.add('filters__mobile--active');

      if (!website.body.classList.contains('no-scroll')) {
        website.body.classList.add('no-scroll');
      }
    }

    if (event) {
      event.preventDefault();
    }
  },
    openFilterLevel: (item) => {
    /*    
    const oCurrentFilterSubLevel = item.querySelector('.filters__mobile__level');
    oCurrentFilterSubLevel.classList.add('filters__mobile__level--active');
    */
  },
    closeFilterLevel: (event, item) => {
    /*
    const oLevel = item.closest('.filters__mobile__level--active');
    if (oLevel) {
      oLevel.classList.remove('filters__mobile__level--active');
    }
    */
    event.stopPropagation();
  },
  scrollToProduct: () => {
    /*
    if (docCookies.getItem('configuratorFiltersScrollTo') !== null && window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD) {
        const oProductToScrollTo = document.querySelector(`[data-articlecode="${docCookies.getItem('configuratorFiltersScrollTo')}"]`) ?
            document.querySelector(`[data-articlecode="${docCookies.getItem('configuratorFiltersScrollTo')}"]`).parentElement : null;
      if (oProductToScrollTo) {
        imagesLoaded(configuratorFilters.oFilterForm, () => {
          scrollIt(oProductToScrollTo, 0);
          docCookies.removeItem('configuratorFiltersScrollTo', '/', '');
        });
      }
    } else {
      window.scrollTo(0, 0);
    }*/
  },
  removeHiddenClass: () => {
    if (configuratorFilters.oFilterForm.classList.contains('is-hidden')) {
      configuratorFilters.oFilterForm.classList.remove('is-hidden');
    }
  },
  removeLoadingClass: () => {
    if (configuratorFilters.oFilterForm.classList.contains('is-loading')) {
      //configuratorFilters.oFilterForm.classList.remove('is-loading');
    }
  },
  enableFilterWithoutResults: () => {
    // Check for checkboxes that are checked and disabled
    configuratorFilters.aFilterCheckboxes.forEach((checkbox) => {
      if ((checkbox.checked && checkbox.disabled) && checkbox.parentElement.querySelector('.filter__count').textContent === '0') {
        checkbox.disabled = false;
      }
    });
  },
};
